// src/UserCloseIcon.tsx
import { jsx } from "react/jsx-runtime";
var UserCloseIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.58594 15.042H2.08594C2.08594 12.5567 4.10066 10.542 6.58594 10.542C9.07122 10.542 11.0859 12.5567 11.0859 15.042H9.58594C9.58594 13.3851 8.24279 12.042 6.58594 12.042C4.92908 12.042 3.58594 13.3851 3.58594 15.042ZM15.8064 12.5715L14.0859 10.8517L12.3662 12.5715L11.3057 11.511L13.0247 9.79199L11.3057 8.07224L12.3662 7.01174L14.0859 8.73149L15.8057 7.01174L16.8662 8.07224L15.1464 9.79199L16.8662 11.5117L15.8064 12.5715ZM6.58594 9.79199C4.92908 9.79199 3.58594 8.44885 3.58594 6.79199C3.58594 5.13514 4.92908 3.79199 6.58594 3.79199C8.24279 3.79199 9.58594 5.13514 9.58594 6.79199C9.58387 8.44799 8.24194 9.78993 6.58594 9.79199ZM6.58594 5.29199C5.76648 5.29282 5.09935 5.95113 5.08761 6.7705C5.07587 7.58987 5.72386 8.26702 6.54295 8.29133C7.36205 8.31564 8.04906 7.67812 8.08594 6.85949V7.15949V6.79199C8.08594 5.96357 7.41436 5.29199 6.58594 5.29199Z",
        fill: "currentColor"
      }
    )
  }
);

export {
  UserCloseIcon
};
